module.exports = __webpack_public_path__ + "img/Cell-Essence_Film2.9633d61b.jpg";